import React, { FC } from 'react';
import { SelectProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { AgentApplicationStatus } from '~/types/AgentApplication';
import Select from './Select';

const status: Record<string, AgentApplicationStatus> = {
  duplicate: 'duplicate',
  draft: 'draft',
  terminated: 'terminated',
  fillingData: 'fillingData',
  rejected: 'rejected',
  screeningFailed: 'screeningFailed',
  onReview: 'onReview',
  approval: 'approval',
  onboarding: 'onboarding',
  posStage: 'posStage',
  completed: 'completed',
  hardRejected: 'hardRejected',
  screening: 'screening',
  contract: 'contract',
  payment: 'payment',
  submissionFailure: 'submissionFailure',
};
// const statusss = AgentApplicationStatus[] = [

// ]

const ApplicationStatusSelect: FC<SelectProps<string>> = (props) => {
  const { t } = useTranslation('applicationStatus');
  const options = Object.values(status).map((value: any) => ({
    label: t(value),
    value,
    key: value,
  }));

  return <Select showSearch options={options} {...props} />;
};

export default ApplicationStatusSelect;
